export default __webpack_public_path__ + "static/media/saludprox.4dd2b358.svg";